
<div class="padding-20 ui-g" id="c3_searchAccumulatorsModal">
  <!-- KS-7308 -->
  <app-campaign-3-kontable 
  *ngIf="show.table"
  id="searchProductTable"            
  [columns] = "[         
  { field: 'code', title: 'campaign.code' },
  { field: 'description', title: 'campaign.description' },
  { field: 'product_categories', title: 'campaign.category' },
  { field: 'product_department', title: 'campaign.department' },
  { field: 'barcode', title: 'campaign.barcode' }
]"
       
  [paginationType]="paginationType"
  [showInfoButton]="false"            
  [showGlobalFilter]="false"
  [showDetailsButton]="false"
  [showRecoverButton]="false"
  [showAddButton]="false"
  [showDeleteButton]="false"
  [showEditButton]="false"
  [showDeleteButton]="false"
  [allowSelectRow]="true"
  [service]="srvCampaign"
  [methodsNames]="{ list: 'getProductItemCompleteOnlyBarcode', sendExtSearchQuery: 'sendExtSearchQuery' }"
  [kontableParametricSearch] = "kontableParametricSearch"
  (onSelected)="onProductSelected($event)"
  #couponTable>

</app-campaign-3-kontable>  
 <br />
 <br />
 <br />
  
</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/search-product-barcode/campaign-3-search-product-barcode.component.html